<script>
import { number } from "@coders-tm/vue-number-format";
import Swal from "sweetalert2";
import CheckModal from "@/components/CheckModal";
import CompanyAPI from "@/services/company/companyAPI";
import CompanySSOAPI from "@/services/sso/company/companySSO.API";
import CopasstActAPI from "@/services/standards/copasst/copasstActAPI";
import CandidatesCopasstAPI from "@/services/standards/copasst/candidates/candidatesAPI";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import { sendNotification } from "@/utils/helpers/notification";

import ItemAPI from "@/services/items/itemsAPI";
import uploadDocument from "@/utils/digitalOcean/digitalocean-upload-file";

export default {
  components: {
    number,
    CheckModal,
  },
  data() {
    return {
      showNotification: false,
      message: "",
      number: {
        separator: ".",
        precision: 0,
        masked: false,
        min: 0,
        max: 50,
        minimumFractionDigits: 0,
        nullValue: 0,
      },
      item: null,
      itemStatus: null,
      itemData: null,
      file: null,
      copasstAct: {
        id: null,
        id_diseno_sso: null,
        employee_id: null,
        appointment_date: null,
        withdrawal_date: null,
        status: false,
        company_name: null,
        course_start_date: null,
        certificate: null,
      },
      postulatesNumber: 10,
      postulates: [],
      candidates: [],
      company: null,
      positions: [
        {
          id: 1,
          name: "REPRESENTANTE EMPLEADOS",
        },
        {
          id: 2,
          name: "SUPLENTE REPRESENTANTE EMPLEADOS",
        },
      ],
      exist: false,
      copasstID: this.$route.params.copasst,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading1: true,
      loading2: true,
      loading3: true,
    };
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(7)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method indicates whether the company has a classification corresponding to
     * the permit for the item in question.
     * @param {JSON} item The item object.
     */
    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 7)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * Get file name with format.
     * @param {String} file Is the name the file.
     * @return {String} The new format the file name.
     */
    getFile(file) {
      try {
        const name = file.split("/");
        return name[name.length - 1];
      } catch (error) {
        console.log(error);
        return file;
      }
    },

    /**
     * This method allows change the status of the showNotification variable.
     */
    setShowNotification() {
      this.showNotification = !this.showNotification;
    },

    /**
     * This method is called when the user clicks on the button to upload the ARL training_copasst_url.
     */
    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    /**
     * This method is used to upload the ARL training_copasst_url to Digital Ocean.
     */
    async uploadDocument(id, file, certificate) {
      try {
        const url = `${this.company}/standards/CopasstTraining/${id}/${file.name}`;
        const result = await uploadDocument(url, file);
        if (result) {
          return true;
        } else return false;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * This method is used to get the company data.
     */
    getCompany() {
      CompanyAPI.getCompany(this.companyID)
        .then((res) => {
          CompanySSOAPI.getCompany(res.uuid)
            .then((r) => {
              this.company = r.nit;
              this.loading1 = false;
            })
            .catch((err) => {
              console.log("SSO Company error: ", err);
            });
        })
        .catch((err) => {
          console.log("Company error: ", err);
        });
    },

    /**
     * This method is used to know if the Copasst Act exists.
     * If exists, it will get the data.
     * If not, it will create a new Copasst Act.
     */
    getCopasst() {
      CopasstActAPI.getActById(this.copasstID)
        .then((response) => {
          const copasst = response[0] || null;
          this.exist = true;
          if (copasst) {
            this.copasstAct = copasst;
            this.postulates = copasst.copasst_candidates.filter(
              (candidate) => candidate.is_distinguished === 0
            );
          } else {
            this.exist = false;
          }

          this.loading2 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getPositions() {
      let positions = [
        "REPRESENTANTE EMPLEADOS",
        "SUPLENTE REPRESENTANTE EMPLEADOS",
      ];
      this.positions = this.postulates.map((postulate) =>
        this.positions.filter(
          (position) => position != postulate.copasst_status
        )
      );
    },

    /**
     * This method is used to go back to the previous page.
     */
    goBack() {
      this.$router.go(-1);
    },

    getName(id) {
      if (id) {
        return this.candidates.find((candidate) => candidate.id === id)
          .full_name;
      } else {
        return "";
      }
    },

    print(url) {
      window.location.href = url;
    },

    /**
     * This method is used to get the possible candidates.
     * This candidadtes are the employees with contract type 1 and status active.
     * Is require the company ID.
     */
    getCandidates() {
      CandidatesCopasstAPI.getAllPossibleCandidates(this.companyID)
        .then((response) => {
          this.candidates = response.data;
          this.loading3 = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    save() {
      const promises = this.postulates.map((postulate) => {
        const { training_copasst_url } = postulate;
        return this.uploadDocument(
          postulate.employee.identification_number,
          training_copasst_url,
          postulate.training_copasst_url
        );
      });

      Promise.all(promises)
        .then((result) => {
          const res = result.find((value) => !value) || false;
          if (!res) {
            Swal.fire({
              title: "¡La subida de archivos fue exitosa!",
              type: "success",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          } else {
            Swal.fire({
              title: "Hubo un error en la subida de uno de los archivos",
              type: "warning",
              confirmButtonClass: "btn btn-confirm mt-2",
            });
          }

          const promisesPostulates = this.postulates.map((postulate) => {
            let url = null;

            try {
              if (postulate.training_copasst_url.name) {
                url = `${process.env.VUE_APP_BUCKET}/${this.company}/standards/CopasstTraining/${postulate.employee.identification_number}/${postulate.training_copasst_url.name}`;
              } else {
                url = postulate.training_copasst_url;
              }
            } catch (error) {
              console.log(error);
              url = postulate.training_copasst_url;
            } finally {
              return CandidatesCopasstAPI.updateTraining(postulate.id, url);
            }
          });

          let resultado = null;

          Promise.all(promisesPostulates)
            .then((result) => {
              CopasstActAPI.getActById(this.copasstID)
                .then((response) => {
                  const copasst = response[0] || null;
                  const post = copasst.copasst_candidates.filter(
                    (candidate) => candidate.is_distinguished === 0
                  );
                  resultado =
                    post.find((postulado) => !postulado.training_copasst_url) ||
                    false;

                  if (!resultado) {
                    ScoreAPI.saveScore(this.companyID, 7)
                      .then((response) => {
                        this.sendNotification(13, 7, true);

                        setTimeout(() => {
                          Swal.fire({
                            title: "¡Se ha registrado con éxito!",
                            type: "success",
                            confirmButtonClass: "btn btn-confirm mt-2",
                          });

                          window.location.reload();
                        }, 1000);
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  } else {
                    setTimeout(() => {
                      Swal.fire({
                        title: "¡Se ha registrado con éxito!",
                        type: "success",
                        confirmButtonClass: "btn btn-confirm mt-2",
                      });

                      window.location.reload();
                    }, 1000);
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            })
            .catch((error) => {
              console.log(error);

              setTimeout(() => {
                Swal.fire({
                  title: "¡Se ha registrado con éxito!",
                  type: "success",
                  confirmButtonClass: "btn btn-confirm mt-2",
                });

                window.location.reload();
              }, 1000);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.getCompany();
    this.getCopasst();
    this.getCandidates();
    this.getItems();
    this.getItemData();
  },
};
</script>

<template>
  <form class="form-group" @submit.prevent="save">
    <div v-if="!loading1 && !loading2 && !loading3">
      <div class="form-row pt-3">
        <b-form-group class="col-md-4 col-sm-12 px-2" label="Fecha asignación del Copasst" label-for="copasstDate">
          <b-form-input type="date" id="input-sm" v-model="copasstAct.announcement_date" disabled>
          </b-form-input>
        </b-form-group>
        <div class="col-md-5 col-sm-12"></div>
        <b-form-group class="text-center col-md-3 col-sm-12 px-2" label="Descargar evaluación de capacitación"
          label-for="copasstCertificate">
          <button class="btn btn-outline-primary btn-md" type="button" @click="downloadTrainingDoc()">
            <i class="bx bx-download"></i>
          </button>
        </b-form-group>
      </div>

      <hr />

      <div class="row">
        <div class="col-lg-12">
          <div>
            <div class="card-body">
              <h4>Postulados Empleados</h4>

              <div>
                <table class="
                    pt-2
                    table table-sm table-responsive
                    border-bottom
                    max-w-full
                    divide-y divide-gray-200
                    table-striped
                    rounded
                    col-sm-12
                  ">
                  <thead class="table-active">
                    <tr>
                      <th scope="col" class="
                          px-6
                          text-left text-xs
                          font-medium
                          text-gray-500
                          align-middle
                          mx-2
                          col-sm-3
                        ">
                        Nombre
                      </th>
                      <th scope="col" class="
                          px-6
                          text-left text-xs
                          font-medium
                          text-gray-500
                          align-middle
                          mx-2
                          col-sm-4
                        ">
                        Cargo Copasst
                      </th>
                      <th scope="col" class="
                          px-6
                          text-left text-xs
                          font-medium
                          text-gray-500
                          align-middle
                          mx-2
                          col-sm-3
                        ">
                        Evaluación de capacitación
                      </th>
                      <th scope="col" class="
                          px-6
                          text-left text-xs
                          font-medium
                          text-gray-500
                          align-middle
                          mx-2
                          col-sm-3
                        ">
                        Descargar evaluación
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200" v-if="postulates.length > 0">
                    <tr v-for="postulate in postulates" :key="postulate.id">
                      <td class="px-6 text-sm text-gray-500 mx-2">
                        <div class="form-control input disabled">
                          {{ getName(postulate.employee_id) }}
                        </div>
                      </td>

                      <td class="px-6 text-sm text-gray-500 mx-2">
                        <select class="form-control" v-model="postulate.copasst_status" disabled>
                          <option :value="postulate.id < 2 ? null : 0">
                            N/A
                          </option>
                          <option v-for="position in positions" :value="position.id" :key="position.id"
                            v-on:change="getPositions">
                            {{ position.name }}
                          </option>
                        </select>
                      </td>

                      <td class="px-6 text-sm text-gray-500 mx-2 text-left">
                        <b-form-group>
                          <b-form-file :disabled="!allowAccess() ||
                            (!(
                              getRole('Crear') &&
                              !postulate.training_copasst_url
                            ) &&
                              !(
                                getRole('Editar') &&
                                postulate.training_copasst_url
                              ))
                            " type="file" :id="`file${postulate.id}`" :ref="`file${postulate.id}`"
                            :name="`file${postulate.id}`" browse-text="Buscar" :placeholder="postulate.training_copasst_url
                              ? getFile(postulate.training_copasst_url)
                              : `Selecciona un archivo...`
                              " drop-placeholder="Suelta acá..." v-model="postulate.training_copasst_url">
                          </b-form-file>
                        </b-form-group>
                      </td>

                      <td class="text-center">
                        <div class="col-sm-12">
                          <button :disabled="!allowAccess() ||
                            !(
                              getRole('Consultar') &&
                              postulate.training_copasst_url
                            )
                            " class="btn btn-outline-primary" type="button" :id="`download${postulate.id}`"
                            @click="print(postulate.training_copasst_url)">
                            <i class="bx bx-download"></i>
                          </button>
                          <b-tooltip :target="`download${postulate.id}`" placement="left">
                            Descargar evaluación
                          </b-tooltip>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div class="form-group text-right m-b-0 mt-2">
                  <button type="submit" :disabled="!allowAccess() ||
                    (!(getRole('Crear') && exist) &&
                      !(getRole('Editar') && !exist))
                    " class="btn btn-primary mx-1">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="text-center pt-3">
        <b-spinner variant="primary" label="Loading..."></b-spinner>
      </div>
    </div>
  </form>
</template>
